const KEY = "vivi:notifSound";

export const isSoundEnabled = () => { try { return localStorage.getItem(KEY) !== "0"; } catch { return true; } };
export const setSoundEnabled = (on) => { try { localStorage.setItem(KEY, on ? "1" : "0"); } catch {} };

// Breve "ding" a due note via Web Audio (nessun asset). Silenzioso se l'AudioContext è bloccato.
export function playNotifSound() {
  if (!isSoundEnabled()) return;
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const now = ctx.currentTime;
    [[880, 0], [1320, 0.12]].forEach(([freq, dt]) => {
      const o = ctx.createOscillator(); const g = ctx.createGain();
      o.type = "sine"; o.frequency.value = freq;
      g.gain.setValueAtTime(0.0001, now + dt);
      g.gain.exponentialRampToValueAtTime(0.25, now + dt + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, now + dt + 0.25);
      o.connect(g); g.connect(ctx.destination);
      o.start(now + dt); o.stop(now + dt + 0.3);
    });
    setTimeout(() => ctx.close().catch(() => {}), 800);
  } catch {}
}
